<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<div class="modal-content">
  <h1 class="ds-title-4">{{ 'GROW.performance.avb.title' | translate }}</h1>
  <div class="breakdown-header">
    <div>
      <h2 class="ds-heading-2">{{ 'GROW.performance.avc.title' | translate }}</h2>
      <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('accountValueInfo')"></app-ds-icon>
    </div>
    @if (info['accountValueInfo']) {
      @for (paragraph of [1, 2, 3, 4, 5]; track paragraph) {
        <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'GROW.performance.avc.p' + paragraph | translate: { currency: accountCurrency }"></p>
      }
    }
  </div>
  <div class="breakdown-content">
    <!-- Principal invested -->
    @if (overview.principal_amount > 0) {
      <app-ds-info-row [showCustomContent]="true">
        <ng-template #customContent>
          <div class="project-title">
            <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.avc.principal' | translate }}</p>
          </div>

          <div class="project-values">
            <p class="ds-ui-2">{{ overview.principal_amount | thousand: accountCurrency }}</p>

            @if (overview?.principal_in_market_currency?.eur > 0) {
              <p class="ds-ui-3 ds-color-core-neutral-5">
                ({{ overview?.principal_in_market_currency?.eur | thousand: 'EUR' }} +
                {{ overview?.principal_in_market_currency?.chf | thousand: accountCurrency }})
              </p>
            }
          </div>
        </ng-template>
      </app-ds-info-row>
    }
    <!-- Committed -->
    @if (overview.committed_amount > 0) {
      <app-ds-info-row [showCustomContent]="true">
        <ng-template #customContent>
          <div class="project-title">
            <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.avc.committed' | translate }}</p>
          </div>

          <div class="project-values">
            <p class="ds-ui-2">{{ overview.committed_amount | thousand: accountCurrency }}</p>

            @if (overview?.committed_in_market_currency?.eur > 0) {
              <p class="ds-ui-3 ds-color-core-neutral-5">
                ({{ overview?.committed_in_market_currency?.eur | thousand: 'EUR' }} +
                {{ overview?.committed_in_market_currency?.chf | thousand: accountCurrency }})
              </p>
            }
          </div>
        </ng-template>
      </app-ds-info-row>
    }
    <!-- Accrued interest-->
    @if (overview.accrued_interest > 0) {
      <app-ds-info-row [showCustomContent]="true">
        <ng-template #customContent>
          <div class="project-title">
            <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.performance.avc.accrued' | translate }}</p>
          </div>

          <div class="project-values">
            <p class="ds-ui-2">{{ overview.accrued_interest | thousand: accountCurrency }}</p>

            @if (overview?.accrued_interest_in_market_currency?.eur > 0) {
              <p class="ds-ui-3 ds-color-core-neutral-5">
                ({{ overview?.accrued_interest_in_market_currency?.eur | thousand: 'EUR' }} +
                {{ overview?.accrued_interest_in_market_currency?.chf | thousand: accountCurrency }})
              </p>
            }
          </div>
        </ng-template>
      </app-ds-info-row>
    }
    <!-- Cash-->
    @if (overview.cash_amount > 0) {
      <app-ds-info-row [title]="'GROW.performance.avc.cash' | translate" [value]="overview.cash_amount | thousand: accountCurrency"></app-ds-info-row>
    }
  </div>

  <!-- Total account value -->
  <app-ds-info-row
    [showCustomContent]="true"
    [customStyle]="'background-color: var(--color-core-brand-3-2); border-top: medium none; padding-left: var(--spacing-3); padding-right: var(--spacing-3); border-radius: var(--spacing-2); margin-bottom: var(--spacing-12);'"
  >
    <ng-template #customContent>
      <div class="project-title">
        <p class="ds-caption-1 ds-color-core-neutral-7">{{ 'GROW.performance.accountValueBreakdown.totalAccountValue' | translate }}</p>
      </div>

      <div class="project-values">
        <p class="ds-caption-1">{{ portfolioValue | thousand: accountCurrency }}</p>
      </div>
    </ng-template>
  </app-ds-info-row>

  <!-- INVESTED -->
  @if (investments.length > 0) {
    <!-- Principal breakdown -->
    <div class="breakdown-header">
      <div>
        <h2 class="ds-heading-2">{{ 'GROW.performance.ppp.title' | translate }}</h2>
        <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('principalPerProjectInfo')"></app-ds-icon>
      </div>
      @if (info['principalPerProjectInfo']) {
        <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'GROW.performance.ppp.p1' | translate"></p>
      }
    </div>
    <div class="breakdown-content">
      @for (investment of investments; track investment.impact_project_id) {
        <app-ds-info-row [showCustomContent]="true">
          <ng-template #customContent>
            <div class="project-title">
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ investment.impact_project_title }}</p>
            </div>

            <div class="project-values">
              <p class="ds-ui-2">{{ investment.amount_in_account_currency | thousand: accountCurrency }}</p>

              @if (investment.currency !== accountCurrency) {
                <p class="ds-ui-3 ds-color-core-neutral-5">({{ investment.amount | thousand: investment.currency }})</p>
              }
            </div>
          </ng-template>
        </app-ds-info-row>
      }
    </div>
  }
  <!-- COMMITTED -->
  @if (commitments.length > 0) {
    <div class="breakdown-header">
      <div>
        <h2 class="ds-heading-2">{{ 'GROW.performance.accountValueBreakdown.committed.title' | translate }}</h2>
        <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('committedInfo')"></app-ds-icon>
      </div>
      @if (info['committedInfo']) {
        <p class="ds-ui-3 ds-color-core-neutral-7">
          {{ 'GROW.performance.accountValueBreakdown.committed.info' | translate }}
        </p>
      }
    </div>
    <div class="breakdown-content">
      @for (commitment of commitments; track commitment.impact_project_id) {
        <app-ds-info-row [showCustomContent]="true">
          <ng-template #customContent>
            <div class="project-title">
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ commitment.impact_project_title }}</p>
            </div>

            <div class="project-values">
              <p class="ds-ui-2">{{ commitment.amount_in_account_currency | thousand: accountCurrency }}</p>

              @if (commitment.currency !== accountCurrency) {
                <p class="ds-ui-3 ds-color-core-neutral-5">({{ commitment.amount | thousand: commitment.currency }})</p>
              }
            </div>
          </ng-template>
        </app-ds-info-row>
      }
    </div>
  }
</div>
